<nav class="lower bg_black_high_emphasis">
	<div class="container justify_content_space_between">

		<div class="left align_items_center">
			<button [routerLink]="" [matMenuTriggerFor]="categoryMenu" #triggerCategory="matMenuTrigger" [attr.aria-expanded]="triggerCategory.menuOpen" aria-controls="categoryMenu" class="color_white_high_emphasis fw700 align_items_center full_height only_gt_md">
				CATEGORÍAS
				<mat-icon class="color_white_high_emphasis">arrow_drop_down</mat-icon>
			</button>

			<a class="color_white_high_emphasis fw700 full_height align_items_center" [routerLink]="routerService.SEARCH" [queryParams]="{d: '10,100'}" [routerLinkActive]="'color_primary_200'">
				OFERTAS
			</a>
			
			<a class="color_white_high_emphasis fw700 full_height align_items_center" [routerLink]="routerService.ECOTRENDS" [routerLinkActive]="'color_primary_200'">
				ECOTRENDS
			</a>
	
			<a class="color_white_high_emphasis fw700 full_height align_items_center" [routerLink]="routerService.PRODUCT_FORM" [routerLinkActive]="'color_primary_200'">
				VENDER
			</a>
		</div>

		<div class="right align_items_center overflow_hidden" *ngIf="user" @fadeInLeft>
			<a mat-icon-button disableRipple draggable="false" class="full_height" [routerLink]="routerService.MY_PURCHASES" [queryParams]="{tab: eMyPurchasesPageTabString.FAVORITES}" matTooltip="Favoritos">
				<mat-icon color="primary">favorite</mat-icon>
			</a>

			<button mat-icon-button disableRipple draggable="false" [matMenuTriggerFor]="notificationsMenu" class="full_height" matTooltip="Notificaciones"  #triggerNotifications="matMenuTrigger" [attr.aria-expanded]="triggerNotifications.menuOpen" tabIndex="0" (menuOpened)="onNotificationsOpened()">
				<mat-icon color="primary" [matBadge]="cNotifications" [matBadgeHidden]="!cNotifications" matBadgeSize="small" matBadgeColor="accent">{{ cNotifications ? "notifications_active" : "notifications" }}</mat-icon>
			</button>

			<a mat-icon-button disableRipple draggable="false" class="full_height" [routerLink]="routerService.CARTS" matTooltip="Carrito">
				<mat-icon color="primary" [matBadge]="cartBadgeNumber" [matBadgeHidden]="!cartBadgeNumber" matBadgeSize="small" matBadgeColor="accent">shopping_cart</mat-icon>
			</a>

			<button [matMenuTriggerFor]="userMenu" #triggerUser="matMenuTrigger" [attr.aria-expanded]="triggerUser.menuOpen" class="clear full_height align_items_center pointer margin_left_very_small" aria-label="Menú de usuario">
				<app-avatar [size]="'40px'"></app-avatar>
			</button>
		</div>
	</div>
</nav>

<!-- #region Mat Menus -->
<mat-menu #categoryMenu id="categoryMenu" class="header_mat_menu">
	<a mat-menu-item *ngFor="let c of categories" [routerLink]="'/buscar'" [queryParams]="{c: c.id}">	<!-- Sin routerLinkActive porque no se actualiza al cambiar de categoría desde este menú, estando en la página de buscar-->
		<span class="fw500">{{ c.title }}</span>
	</a>
</mat-menu>

<mat-menu #userMenu class="header_mat_menu no_max_width user_menug" xPosition="before">
	<a mat-menu-item class="flex gap_small align_items_center" [routerLink]="routerService.PROFILE">
		<app-avatar [size]="'70px'"></app-avatar>
		<div class="flex1 padding_right_very_small">
			<p class="fw500">
				<ng-container *ngIf="user?.type == eLegalEntityType['Persona física']">{{ user?.firstname }}</ng-container>
				{{ user?.lastname }}
			</p>
			<p class="margin_top_very_small color_black_inactive">{{ user?.email }}</p>
		</div>
	</a>

	<mat-divider></mat-divider>

	<a mat-menu-item [routerLink]="routerService.PROFILE" routerLinkActive="mat_menu_routerLinkActive">
		<mat-icon>manage_accounts</mat-icon>
		<span class="fw500">Mi Perfil</span>
	</a>
	<a mat-menu-item [routerLink]="routerService.MY_PURCHASES" [queryParams]="{tab: eMyPurchasesPageTabString.PURCHASES}" routerLinkActive="mat_menu_routerLinkActive" [routerLinkActiveOptions]="{exact: true}">
		<mat-icon>shopping_bag</mat-icon>
		<span class="fw500">Mis Compras</span>
	</a>
	<a mat-menu-item [routerLink]="routerService.MY_PURCHASES" [queryParams]="{tab: eMyPurchasesPageTabString.QUESTIONS}" routerLinkActive="mat_menu_routerLinkActive" [routerLinkActiveOptions]="{exact: true}">
		<mat-icon>quiz</mat-icon>
		<span class="fw500">Mis Preguntas</span>
	</a>
	<a mat-menu-item [routerLink]="routerService.MY_PURCHASES" [queryParams]="{tab: eMyPurchasesPageTabString.FAVORITES}" routerLinkActive="mat_menu_routerLinkActive" [routerLinkActiveOptions]="{exact: true}">
		<mat-icon>favorite</mat-icon>
		<span class="fw500">Mis Favoritos</span>
	</a>

	<ng-container *ngIf="user?.is_store">
		<p class="not_a_mat_menu_item color_black_inactive fw500">VENDER</p>

		<a mat-menu-item [routerLink]="routerService.MY_SALES" [queryParams]="{tab: eMySalesPageTabString.SALES}" routerLinkActive="mat_menu_routerLinkActive">
			<mat-icon>storefront</mat-icon>
			<span class="fw500">Mis Ventas</span>
		</a>

		<a mat-menu-item [routerLink]="routerService.MY_SALES" [queryParams]="{tab: eMySalesPageTabString.QUESTIONS}" routerLinkActive="mat_menu_routerLinkActive">
			<mat-icon>question_answer</mat-icon>
			<span class="fw500">Preguntas a mis publicaciones</span>
		</a>

		<a mat-menu-item [routerLink]="routerService.MY_SALES" [queryParams]="{tab: eMySalesPageTabString.PUBLICATIONS}" routerLinkActive="mat_menu_routerLinkActive">
			<mat-icon>local_offer</mat-icon>
			<span class="fw500">Mis publicaciones</span>
		</a>
	</ng-container>

	<mat-divider></mat-divider>

	<a mat-menu-item (click)="logout()">
		<mat-icon color="warn">logout</mat-icon>
		<span class="fw500">Cerrar sesión</span>
	</a>
</mat-menu>

<mat-menu #notificationsMenu class="header_mat_menu notifications_menu" xPosition="before">
	<app-notifications-panel
		#notificationsPanel
		*ngIf="notifications"
		[notifications]="notifications"
		(eeOneDown)="cNotifications = cNotifications!-1"
		(eeAllCleared)="cNotifications = 0;"
	></app-notifications-panel>
</mat-menu>
<!-- #endregion -->